<template lang="pug">
AppDialog#delete-job-confirm(
  show
  size="smedium"
  has-footer
  append-to-body
  title="Delete recurring job"
  @close="$emit('cancel')"
)
  p Select what you wish to delete.
  .d-flex.flex-column.mt-30
    label.d-flex.align-items-center.m-0.mb-10(for="individual")
      input#individual(
        v-model="allSelected"
        type="radio"
        name="individual"
        :value="false"
        :checked="!allSelected"
      )
      | Just this individual job

    label.d-flex.align-items-center.m-0.mb-10(for="all")
      input#all(
        v-model="allSelected"
        type="radio"
        name="all"
        :value="true"
        :checked="allSelected"
      )
      | All occurrences of this recurring job

  template(#footer)
    AppButton.mr-15(
      type="default"
      @click="$emit('cancel')"
    ) Cancel
    AppButton(
      type="danger"
      :disabled="loading"
      @click="onClick"
    ) Delete
</template>

<script>
export default {
  name: 'WorkOrdersConfirmDeleteRecurringJobsDialog',
  data: () => ({
    loading: false,
    allSelected: false,
  }),
  methods: {
    onClick() {
      this.loading = true;
      this.$emit('confirm', this.allSelected);
    },
  },
};
</script>
